export default "__VITE_ASSET__BUvkYvui__";